import authUserActions from '../authuser/actions'
import actions from './actions'
import crudReducers from '../crud/reducers'
import {initialDataState, reduceDataError, reduceDataRequest, reduceDataSuccess} from '../../reducersHelper'

const dataPropName = 'provideruser'

const initState = {
  list: [],
  listLoaded: false,
  loading: false,
  loaded: false,
  error: false,
  modalActive: false,
  parent: {
    providerId: null,
    name: '',
    code: ''
  },
  [dataPropName]: {
    userId: null,
    firstName: '',
    lastName: '',
    email: '',
    username: ''
  },
  userSearch: initialDataState,
  avatar: initialDataState,
  allAvatars: {...initialDataState, scope: null, requestId: null},
  userPassword: initialDataState,

}

const crud = crudReducers(actions, dataPropName, initState)

const reducers = (state = initState, action) => {
  switch (action.type) {
    case authUserActions.GET_USER_SUCCESS:
      if (state.allAvatars.providerId === action.user.providerId) return state
      return {
        ...state,
        avatar: initialDataState,
        allAvatars: {...initialDataState, providerId: action.user.providerId, scope: action, requestId: null}
      }

    case actions.CLEAR_USER_AVATAR:
      return {
        ...state,
        avatar: initialDataState
      }
    case actions.GET_USER_AVATAR_REQUEST:
      return reduceDataRequest(state, 'avatar')
    case actions.GET_USER_AVATAR_SUCCESS:
      return reduceDataSuccess(state, 'avatar', action.payload)
    case actions.GET_USER_AVATAR_ERROR:
      return reduceDataError(state, 'avatar', action.error)
    case actions.UPDATE_USER_AVATAR_REQUEST:
    case actions.DELETE_USER_AVATAR_REQUEST:
      // Invalidate both before and after a mutation: a bulk read started while
      // the write is in progress must not become the new valid cache.
      return {
        ...reduceDataRequest(state, 'avatar'),
        allAvatars: {...state.allAvatars, loading: false, loaded: false, requestId: action.avatarScope}
      }
    case actions.UPDATE_USER_AVATAR_SUCCESS:
    case actions.DELETE_USER_AVATAR_SUCCESS:
      return {
        ...reduceDataSuccess(state, 'avatar', action.type === actions.DELETE_USER_AVATAR_SUCCESS ? null : action.payload),
        allAvatars: {...initialDataState, providerId: state.allAvatars.providerId, scope: state.allAvatars.scope, requestId: action.avatarScope}
      }
    case actions.UPDATE_USER_AVATAR_ERROR:
    case actions.DELETE_USER_AVATAR_ERROR:
      return reduceDataError(state, 'avatar', action.error)
    case actions.GET_ALL_USER_AVATARS_REQUEST:
      if (state.allAvatars.scope !== action.ids.scope || state.allAvatars.providerId !== action.ids.providerId) return state
      if (state.allAvatars.requestId !== action.ids.previousRequestId && state.allAvatars.requestId !== action.ids.requestId) return state
      return {...state, allAvatars: {
        ...initialDataState, loading: true, providerId: action.ids.providerId,
        requestId: action.ids.requestId,
        scope: state.allAvatars.scope
      }}
    case actions.GET_ALL_USER_AVATARS_SUCCESS:
      if (state.allAvatars.requestId !== action.ids.requestId) return state
      return reduceDataSuccess(state, 'allAvatars', action.payload)
    case actions.GET_ALL_USER_AVATARS_ERROR:
      if (state.allAvatars.requestId !== action.ids.requestId) return state
      return reduceDataError(state, 'allAvatars', action.error)
    case actions.SEARCH_PROVIDERUSERS_REQUEST:
      return reduceDataRequest(state, 'userSearch')
    case actions.SEARCH_PROVIDERUSERS_SUCCESS:
      return reduceDataSuccess(state, 'userSearch', action.payload)
    case actions.SEARCH_PROVIDERUSERS_ERROR:
      return reduceDataError(state, 'userSearch', action.error)
    // case actions.GET_USER_PASSWORD_RESET_LINK_REQUEST:
    //   return reduceDataRequest(state, 'passwordResetLink')
    // case actions.GET_USER_PASSWORD_RESET_LINK_SUCCESS:
    //   return reduceDataRequest(state, 'passwordResetLink')
    // case actions.GET_USER_PASSWORD_RESET_LINK_ERROR:
    //   return reduceDataRequest(state, 'passwordResetLink')

    case actions.UPDATE_USER_PASSWORD_REQUEST:
      return reduceDataRequest(state, 'userPassword')
    case actions.UPDATE_USER_PASSWORD_SUCCESS:
      return reduceDataSuccess(state, 'userPassword', action.payload)
    case actions.UPDATE_USER_PASSWORD_ERROR:
      return reduceDataError(state, 'userPassword', action.error)

    default:
      return crud(state, action)
  }
}

export default reducers
